import * as React from 'react'
import FilterSort from '../FilterSort'
import styles from './index.module.scss'

interface Props {
  initData?: any
  filterForm?: any
  data: any[]
  handleChange: Function
  isSearch?: boolean // 搜索页
  hideOnSale?: boolean // 隐藏on sale
  showInStock?: boolean // 显示in stock
  showQuickShip?: boolean
  isFixedFilter?: boolean
}

const FixedFilter: React.FunctionComponent<Props> = (props?: any) => {
  const { data } = props
  const newFliterList =
    data?.filter((i) => Number(i.showInTopFilter) === 1) || []

  return (
    <div className={styles['fixed-category-wrap']}>
      <FilterSort {...props} data={newFliterList} isFixedFilter={true} />
    </div>
  )
}

export default FixedFilter
